import React from 'react';
import styles from './Reports.module.css';

// "Use a ready-made comment" dropdown. `groups` is one of the lists from
// GET /reports/cards/comment-templates ([{band, label, comments}]); `bands`
// is its `bands` list. Picking one hands the text to onPick — it only fills
// the box, which the user can still edit. When a mark is given, the group
// that matches it is listed first and marked as suggested.
function CommentTemplatePicker({ groups, bands, mark, onPick, label = 'Use a ready-made comment…' }) {
  if (!groups || groups.length === 0) return null;

  const suggested = mark === null || mark === undefined ? null : (bands || []).find((band) => mark >= band.min_mark)?.key;
  const ordered = suggested ? [...groups.filter((group) => group.band === suggested), ...groups.filter((group) => group.band !== suggested)] : groups;

  return (
    <select
      className={styles.templateSelect}
      value=""
      onChange={(e) => { if (e.target.value) onPick(e.target.value); }}
      aria-label={label}
    >
      <option value="">{label}</option>
      {ordered.map((group) => (
        <optgroup key={group.band} label={group.band === suggested ? `${group.label} (suggested for this mark)` : group.label}>
          {group.comments.map((comment) => <option key={comment} value={comment}>{comment}</option>)}
        </optgroup>
      ))}
    </select>
  );
}

export default CommentTemplatePicker;
